<template>
    <v-flex xs12 class="pa-2">
        <v-card class="pa-2">
            <v-combobox
                v-model="selectedTags"
                :items="tags"
                :menu-props="{ closeOnContentClick: true }"
                hide-selected
                label="Tags"
                item-text="name"
                item-value="slug"
                multiple
                persistent-hint
                small-chips
                return-object
                @change="search"
            />

            {{ nbResults }}
        </v-card>
    </v-flex>
</template>

<script>
    import {DOCUMENT_SEARCH, TAGS_FETCH} from "../../store/actions.type";
    import {mapGetters} from "vuex";

    export default {
        name: "DocumentSearchForm",
        data: () => ({
            loading: false,
            selectedTags: [],
        }),
        computed: {
            ...mapGetters(["tags", "medias"]),
            nbResults: function() {
                return this.medias && this.medias.length > 0 ? this.medias.length + ' résultats' : '';
            }
        },
        mounted() {
            this.$store.dispatch(TAGS_FETCH);
        },
        methods: {
            /**
             * Soumission du formulaire
             */
            search() {
                if (this.selectedTags.length) {
                    let slugs = this.selectedTags.map(item => item.slug);
                    this.$store.dispatch(DOCUMENT_SEARCH, slugs);
                }
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
